import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { delay, share } from 'rxjs/operators';

@Injectable()
export class ChartTypeService {

  private messageSource = new BehaviorSubject<string>("defaultMessage");
  currentMessage = this.messageSource.asObservable();

  changeChartType(message: string) {
    this.messageSource.next(message);
  }
}
